import { Injectable } from '@angular/core';
import { PDFFormType } from '@models/matter-form-data';
import { BaseFormMapper } from './base-form-mapper';
import { LTT_AFFIDAVIT_FORM_Mapper } from './ltt/ltt_affidavit_form';
import { LTT_REBATE_FORM_Mapper } from './ltt/ltt_rebate_form';
import { MLTT_AFFIDAVIT_FORM_Mapper } from './mltt/mltt_affidavit_form';
import { MLTT_REBATE_FORM_Mapper } from './mltt/mltt_rebate_form';
import { MLTT_SUPPLEMENTARY_FORM_Mapper } from './mltt/mltt_supplementary_form';
import { BMO_COLLATERAL_FINAL_REPORT_Mapper } from './mortgage/bmo/bmo_collateral_final_report';
import { BMO_COLLATERAL_REQUEST_FOR_FUNDS_Mapper } from './mortgage/bmo/bmo_collateral_request_for_funds';
import { BMO_COLLATERAL_SCHEDULE_Mapper } from './mortgage/bmo/bmo_collateral_schedule';
import { BMO_COLLATERAL_STANDARD_CHARGE_TERMS_Mapper } from './mortgage/bmo/bmo_collateral_standard_charge_terms';
import { BMO_CONVENTIONAL_ACKNOWLEDGEMENT_AND_DIRECTION_Mapper } from './mortgage/bmo/bmo_conventional_acknowledgement_and_direction';
import { BMO_CONVENTIONAL_COVER_SHEET_Mapper } from './mortgage/bmo/bmo_conventional_cover_sheet';
import { BMO_CONVENTIONAL_FINAL_REPORT_Mapper } from './mortgage/bmo/bmo_conventional_final_report';
import { BMO_CONVENTIONAL_ID_VERIFICATION_Mapper } from './mortgage/bmo/bmo_conventional_id_verification';
import { BMO_CONVENTIONAL_MTG_DECLARATION_OF_POSSESSION_Mapper } from './mortgage/bmo/bmo_conventional_mtg_declaration_of_possession';
import { BMO_CONVENTIONAL_REQUEST_FOR_FUNDS_Mapper } from './mortgage/bmo/bmo_conventional_request_for_funds';
import { BMO_CONVENTIONAL_RESIDENTIAL_MORTGAGE_SCHEDULE_Mapper } from './mortgage/bmo/bmo_conventional_residential_mortgage_schedule';
import { CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_FINAL_REPORT_Mapper } from './mortgage/cibc/cibc_documents_collateral_mortgage_final_report';
import { CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_NOTIFICATION_OF_REGISTRATION_Mapper } from './mortgage/cibc/cibc_documents_collateral_mortgage_notification_of_registration';
import { CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS_Mapper } from './mortgage/cibc/cibc_documents_collateral_mortgage_request_for_funds';
import { CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_FINAL_REPORT_Mapper } from './mortgage/cibc/cibc_documents_commercial_collateral_mortgage_final_report';
import { CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS_Mapper } from './mortgage/cibc/cibc_documents_commercial_collateral_mortgage_request_for_funds';
import { CIBC_DOCUMENTS_HOME_POWER_PLAN_FINAL_REPORT_Mapper } from './mortgage/cibc/cibc_documents_home_power_plan_final_report';
import { CIBC_DOCUMENTS_HOME_POWER_PLAN_ID_VERIFICATION_Mapper } from './mortgage/cibc/cibc_documents_home_power_plan_id_verification';
import { CIBC_DOCUMENTS_HOME_POWER_PLAN_REQUEST_FOR_FUNDS_Mapper } from './mortgage/cibc/cibc_documents_home_power_plan_request_for_funds';
import { CIBC_DOCUMENTS_HOME_POWER_PLAN_STANDARD_CHARGE_TERMS_Mapper } from './mortgage/cibc/cibc_documents_home_power_plan_standard_charge_terms';
import { CIBC_DOCUMENTS_MORTGAGE_FINAL_REPORT_Mapper } from './mortgage/cibc/cibc_documents_mortgage_final_report';
import { CIBC_DOCUMENTS_MORTGAGE_ID_VERIFICATION_Mapper } from './mortgage/cibc/cibc_documents_mortgage_id_verification';
import { CIBC_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS_Mapper } from './mortgage/cibc/cibc_documents_mortgage_request_for_funds';
import { CIBC_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS_Mapper } from './mortgage/cibc/cibc_documents_mortgage_standard_charge_terms';
import { CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_FINAL_REPORT_Mapper } from './mortgage/cibc/cibc_documents_splc_for_purchase_final_report';
import { CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_REQUEST_FOR_FUNDS_Mapper } from './mortgage/cibc/cibc_documents_splc_for_purchase_request_for_funds';
import { CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_FINAL_REPORT_Mapper } from './mortgage/cibc/cibc_simplii_financial_documents_mortgage_final_report';
import { CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS_Mapper } from './mortgage/cibc/cibc_simplii_financial_documents_mortgage_request_for_funds';
import { CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS_Mapper } from './mortgage/cibc/cibc_simplii_financial_documents_mortgage_standard_charge_terms';
import { CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_FINAL_REPORT_Mapper } from './mortgage/cibc/cibc_simplii_financial_documents_secure_line_of_credit_final_report';
import { CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_REQUEST_FOR_FUNDS_Mapper } from './mortgage/cibc/cibc_simplii_financial_documents_secure_line_of_credit_request_for_funds';
import { HOME_TRUST_ACKNOWLEDGEMENT_AND_DIRECTION_REFUNDS_Mapper } from './mortgage/home_trust/home_trust_acknowledgement_and_direction_refunds';
import { HOME_TRUST_AUTHORIZATION_DIRECTION_AND_CONSENT_Mapper } from './mortgage/home_trust/home_trust_authorization_direction_and_consent';
import { HOME_TRUST_FINAL_REPORT_Mapper } from './mortgage/home_trust/home_trust_final_report';
import { HOME_TRUST_PAYMENT_CHANGE_REQUEST_FORM_Mapper } from './mortgage/home_trust/home_trust_payment_change_request_form';
import { HOME_TRUST_PREAUTHORIZED_DEBIT_AGREEMENT_Mapper } from './mortgage/home_trust/home_trust_preauthorized_debit_agreement';
import { HOME_TRUST_REQUEST_FOR_FUNDS_Mapper } from './mortgage/home_trust/home_trust_request_for_funds';
import { HOME_TRUST_SOLICITOR_DECLARATION_REIDENTIFICATION_Mapper } from './mortgage/home_trust/home_trust_solicitor_declaration_reidentification';
import { HOME_TRUST_STANDARD_CHARGE_TERMS_Mapper } from './mortgage/home_trust/home_trust_standard_charge_terms';
import { HOME_TRUST_STATUTORY_DECLARATION_Mapper } from './mortgage/home_trust/home_trust_statutory_declaration';
import { HOME_TRUST_TENANT_ACKNOWLEDGEMENT_Mapper } from './mortgage/home_trust/home_trust_tenant_acknowledgement';
import { FIRST_NATIONAL_REQUEST_FOR_FUNDS_Mapper } from './mortgage/first_national/first_national_request_for_funds';
import { FIRST_NATIONAL_FINAL_REPORT_ON_TITLE_Mapper } from './mortgage/first_national/first_national_final_report_on_title';
import { TD_REQUEST_FOR_FUNDS_Mapper } from './mortgage/td/td_request_for_funds';
import { TD_FINAL_REPORT_Mapper } from './mortgage/td/td_final_report';
import { TD_FACE_TO_FACE_ID_Mapper } from './mortgage/td/td_face_to_face_id';
import { TD_PRIVACY_AGREEMENT_Mapper } from './mortgage/td/td_privacy_agreement';
import { TD_NON_FACE_TO_FACE_ID_Mapper } from './mortgage/td/td_non_face_to_face_id';
import { TD_SCHEDULE_1_Mapper } from './mortgage/td/td_schedule_1';
import { RBC_COLLATERAL_FINAL_REPORT_Mapper } from './mortgage/rbc/rbc_collateral_final_report';
import { RBC_COLLATERAL_REQUEST_FOR_FUNDS_Mapper } from './mortgage/rbc/rbc_collateral_request_for_funds';
import { RBC_COLLATERAL_SCHEDULE_FIXED_RATE_Mapper } from './mortgage/rbc/rbc_collateral_schedule_fixed_rate';
import { RBC_RESIDENTIAL_SCHEDULE_PRIME_RATE_Mapper } from './mortgage/rbc/rbc_collateral_schedule_prime_rate';
import { RBC_RESIDENTIAL_STANDARD_CHARGE_TERMS_Mapper } from './mortgage/rbc/rbc_collateral_standard_charge_terms';
import { RBC_RESIDENTIAL_ASSIGNMENT_OF_SITE_LEASE_Mapper } from './mortgage/rbc/rbc_residential_assignment_of_site_lease';
import { RBC_RESIDENTIAL_FINAL_REPORT_Mapper } from './mortgage/rbc/rbc_residential_final_report';
import { RBC_RESIDENTIAL_LANDLORD_CONSENT_Mapper } from './mortgage/rbc/rbc_residential_landlord_consent';
import { RBC_RESIDENTIAL_LETTER_FOR_ILA_Mapper } from './mortgage/rbc/rbc_residential_letter_for_ILA';
import { RBC_RESIDENTIAL_LETTER_OF_DIRECTION_Mapper } from './mortgage/rbc/rbc_residential_letter_of_direction';
import { RBC_RESIDENTIAL_REQUEST_FOR_FUNDS_Mapper } from './mortgage/rbc/rbc_residential_request_for_funds';
import { RBC_RESIDENTIAL_SCT_FIXED_Mapper } from './mortgage/rbc/rbc_residential_sct_fixed';
import { RBC_RESIDENTIAL_SCT_VARIABLE_Mapper } from './mortgage/rbc/rbc_residential_sct_variable';
import { RBC_RESIDENTIAL_SECURITY_AGREEMENT_Mapper } from './mortgage/rbc/rbc_residential_security_agreement';
import { STANDALONE_PURCHASE_PRESCRIBED_INFORMATION_FORM_Mapper } from './mortgage/standalone/standalone_purchase_prescribed_information_form';
import { ON_GST_190_APPENDIX_A_Mapper } from './on_gst_190_appendix_a';
import { ON_GST_190_CALCULATION_WS_Mapper } from './on_gst_190_calculation_ws';
import { ON_GST_190_REBATE_SCHEDULE_Mapper } from './on_gst_190_rebate_schedule';
import { ON_GST_524_REBATE_SCHEDULE_Mapper } from './on_gst_524_rebate_schedule';
import { ON_GST_NEW_HOUSING_REBATE_Mapper } from './on_gst_new_housing_rebate';
import { ON_GST_NEW_REBATE_RENTAL_Mapper } from './on_gst_new_rate_rental';
import { FCT_UNDER_25_Mapper } from './commercial/fct_under_25';
import { FCT_OVER_25_Mapper } from './commercial/fct_over_25';

@Injectable({
	providedIn: 'root',
})
export class FormMapper {
	constructor(
		private _ON_GST_190_CALCULATION_WS_Mapper: ON_GST_190_CALCULATION_WS_Mapper,
		private _ON_GST_190_APPENDIX_A_Mapper: ON_GST_190_APPENDIX_A_Mapper,
		private _ON_GST_190_REBATE_SCHEDULE_Mapper: ON_GST_190_REBATE_SCHEDULE_Mapper,
		private _ON_GST_NEW_REBATE_RENTAL_Mapper: ON_GST_NEW_REBATE_RENTAL_Mapper,
		private _ON_GST_NEW_HOUSING_REBATE_Mapper: ON_GST_NEW_HOUSING_REBATE_Mapper,
		private _ON_GST_524_REBATE_SCHEDULE_Mapper: ON_GST_524_REBATE_SCHEDULE_Mapper,
		private _RBC_COLLATERAL_FINAL_REPORT_Mapper: RBC_COLLATERAL_FINAL_REPORT_Mapper,
		private _RBC_COLLATERAL_REQUEST_FOR_FUNDS_Mapper: RBC_COLLATERAL_REQUEST_FOR_FUNDS_Mapper,
		private _RBC_COLLATERAL_SCHEDULE_FIXED_RATE_Mapper: RBC_COLLATERAL_SCHEDULE_FIXED_RATE_Mapper,
		private _RBC_RESIDENTIAL_ASSIGNMENT_OF_SITE_LEASE_Mapper: RBC_RESIDENTIAL_ASSIGNMENT_OF_SITE_LEASE_Mapper,
		private _RBC_RESIDENTIAL_FINAL_REPORT_Mapper: RBC_RESIDENTIAL_FINAL_REPORT_Mapper,
		private _RBC_RESIDENTIAL_LANDLORD_CONSENT_Mapper: RBC_RESIDENTIAL_LANDLORD_CONSENT_Mapper,
		private _RBC_RESIDENTIAL_LETTER_FOR_ILA_Mapper: RBC_RESIDENTIAL_LETTER_FOR_ILA_Mapper,
		private _RBC_RESIDENTIAL_LETTER_OF_DIRECTION_Mapper: RBC_RESIDENTIAL_LETTER_OF_DIRECTION_Mapper,
		private _RBC_RESIDENTIAL_REQUEST_FOR_FUNDS_Mapper: RBC_RESIDENTIAL_REQUEST_FOR_FUNDS_Mapper,
		private _RBC_RESIDENTIAL_SECURITY_AGREEMENT_Mapper: RBC_RESIDENTIAL_SECURITY_AGREEMENT_Mapper,
		private _RBC_RESIDENTIAL_SCT_VARIABLE_Mapper: RBC_RESIDENTIAL_SCT_VARIABLE_Mapper,
		private _RBC_RESIDENTIAL_SCT_FIXED_Mapper: RBC_RESIDENTIAL_SCT_FIXED_Mapper,
		private _RBC_RESIDENTIAL_STANDARD_CHARGE_TERMS_Mapper: RBC_RESIDENTIAL_STANDARD_CHARGE_TERMS_Mapper,
		private _RBC_RESIDENTIAL_SCHEDULE_PRIME_RATE_Mapper: RBC_RESIDENTIAL_SCHEDULE_PRIME_RATE_Mapper,
		private _BMO_COLLATERAL_STANDARD_CHARGE_TERMS_Mapper: BMO_COLLATERAL_STANDARD_CHARGE_TERMS_Mapper,
		private _BMO_COLLATERAL_SCHEDULE_Mapper: BMO_COLLATERAL_SCHEDULE_Mapper,
		private _BMO_COLLATERAL_REQUEST_FOR_FUNDS_Mapper: BMO_COLLATERAL_REQUEST_FOR_FUNDS_Mapper,
		private _BMO_COLLATERAL_FINAL_REPORT_Mapper: BMO_COLLATERAL_FINAL_REPORT_Mapper,
		private _BMO_CONVENTIONAL_COVER_SHEET_Mapper: BMO_CONVENTIONAL_COVER_SHEET_Mapper,
		private _BMO_CONVENTIONAL_ACKNOWLEDGEMENT_AND_DIRECTION_Mapper: BMO_CONVENTIONAL_ACKNOWLEDGEMENT_AND_DIRECTION_Mapper,
		private _BMO_CONVENTIONAL_FINAL_REPORT_Mapper: BMO_CONVENTIONAL_FINAL_REPORT_Mapper,
		private _BMO_CONVENTIONAL_ID_VERIFICATION_Mapper: BMO_CONVENTIONAL_ID_VERIFICATION_Mapper,
		private _BMO_CONVENTIONAL_MTG_DECLARATION_OF_POSSESSION_Mapper: BMO_CONVENTIONAL_MTG_DECLARATION_OF_POSSESSION_Mapper,
		private _BMO_CONVENTIONAL_RESIDENTIAL_MORTGAGE_SCHEDULE_Mapper: BMO_CONVENTIONAL_RESIDENTIAL_MORTGAGE_SCHEDULE_Mapper,
		private _BMO_CONVENTIONAL_REQUEST_FOR_FUNDS_Mapper: BMO_CONVENTIONAL_REQUEST_FOR_FUNDS_Mapper,
		private _HOME_TRUST_TENANT_ACKNOWLEDGEMENT_Mapper: HOME_TRUST_TENANT_ACKNOWLEDGEMENT_Mapper,
		private _HOME_TRUST_STATUTORY_DECLARATION_Mapper: HOME_TRUST_STATUTORY_DECLARATION_Mapper,
		private _HOME_TRUST_STANDARD_CHARGE_TERMS_Mapper: HOME_TRUST_STANDARD_CHARGE_TERMS_Mapper,
		private _HOME_TRUST_SOLICITOR_DECLARATION_REIDENTIFICATION_Mapper: HOME_TRUST_SOLICITOR_DECLARATION_REIDENTIFICATION_Mapper,
		private _HOME_TRUST_REQUEST_FOR_FUNDS_Mapper: HOME_TRUST_REQUEST_FOR_FUNDS_Mapper,
		private _HOME_TRUST_PREAUTHORIZED_DEBIT_AGREEMENT_Mapper: HOME_TRUST_PREAUTHORIZED_DEBIT_AGREEMENT_Mapper,
		private _HOME_TRUST_PAYMENT_CHANGE_REQUEST_FORM_Mapper: HOME_TRUST_PAYMENT_CHANGE_REQUEST_FORM_Mapper,
		private _HOME_TRUST_FINAL_REPORT_Mapper: HOME_TRUST_FINAL_REPORT_Mapper,
		private _HOME_TRUST_AUTHORIZATION_DIRECTION_AND_CONSENT_Mapper: HOME_TRUST_AUTHORIZATION_DIRECTION_AND_CONSENT_Mapper,
		private _HOME_TRUST_ACKNOWLEDGEMENT_AND_DIRECTION_REFUNDS_Mapper: HOME_TRUST_ACKNOWLEDGEMENT_AND_DIRECTION_REFUNDS_Mapper,
		private _FIRST_NATIONAL_REQUEST_FOR_FUNDS_Mapper: FIRST_NATIONAL_REQUEST_FOR_FUNDS_Mapper,
		private _FIRST_NATIONAL_FINAL_REPORT_ON_TITLE_Mapper: FIRST_NATIONAL_FINAL_REPORT_ON_TITLE_Mapper,
		private _TD_REQUEST_FOR_FUNDS_Mapper: TD_REQUEST_FOR_FUNDS_Mapper,
		private _TD_FINAL_REPORT_Mapper: TD_FINAL_REPORT_Mapper,
		private _TD_FACE_TO_FACE_ID_Mapper: TD_FACE_TO_FACE_ID_Mapper,
		private _TD_PRIVACY_AGREEMENT_Mapper: TD_PRIVACY_AGREEMENT_Mapper,
		private _TD_NON_FACE_TO_FACE_ID_Mapper: TD_NON_FACE_TO_FACE_ID_Mapper,
		private _TD_SCHEDULE_1_Mapper: TD_SCHEDULE_1_Mapper,
		private _CIBC_DOCUMENTS_MORTGAGE_FINAL_REPORT_Mapper: CIBC_DOCUMENTS_MORTGAGE_FINAL_REPORT_Mapper,
		private _CIBC_DOCUMENTS_MORTGAGE_ID_VERIFICATION_Mapper: CIBC_DOCUMENTS_MORTGAGE_ID_VERIFICATION_Mapper,
		private _CIBC_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS_Mapper: CIBC_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS_Mapper,
		private _CIBC_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS_Mapper: CIBC_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS_Mapper,
		private _CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_FINAL_REPORT_Mapper: CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_FINAL_REPORT_Mapper,
		private _CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_NOTIFICATION_OF_REGISTRATION_Mapper: CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_NOTIFICATION_OF_REGISTRATION_Mapper,
		private _CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS_Mapper: CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS_Mapper,
		private _CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_FINAL_REPORT_Mapper: CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_FINAL_REPORT_Mapper,
		private _CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS_Mapper: CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS_Mapper,
		private _CIBC_DOCUMENTS_HOME_POWER_PLAN_FINAL_REPORT_Mapper: CIBC_DOCUMENTS_HOME_POWER_PLAN_FINAL_REPORT_Mapper,
		private _CIBC_DOCUMENTS_HOME_POWER_PLAN_ID_VERIFICATION_Mapper: CIBC_DOCUMENTS_HOME_POWER_PLAN_ID_VERIFICATION_Mapper,
		private _CIBC_DOCUMENTS_HOME_POWER_PLAN_REQUEST_FOR_FUNDS_Mapper: CIBC_DOCUMENTS_HOME_POWER_PLAN_REQUEST_FOR_FUNDS_Mapper,
		private _CIBC_DOCUMENTS_HOME_POWER_PLAN_STANDARD_CHARGE_TERMS_Mapper: CIBC_DOCUMENTS_HOME_POWER_PLAN_STANDARD_CHARGE_TERMS_Mapper,
		private _CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_FINAL_REPORT_Mapper: CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_FINAL_REPORT_Mapper,
		private _CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_REQUEST_FOR_FUNDS_Mapper: CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_REQUEST_FOR_FUNDS_Mapper,
		private _CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_FINAL_REPORT_Mapper: CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_FINAL_REPORT_Mapper,
		private _CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS_Mapper: CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS_Mapper,
		private _CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS_Mapper: CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS_Mapper,
		private _CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_FINAL_REPORT_Mapper: CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_FINAL_REPORT_Mapper,
		private _CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_REQUEST_FOR_FUNDS_Mapper: CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_REQUEST_FOR_FUNDS_Mapper,
		private _STANDALONE_PURCHASE_PRESCRIBED_INFORMATION_FORM_Mapper: STANDALONE_PURCHASE_PRESCRIBED_INFORMATION_FORM_Mapper,
		private _LTT_AFFIDAVIT_FORM_MAPPER: LTT_AFFIDAVIT_FORM_Mapper,
		private _LTT_REBATE_FORM_MAPPER: LTT_REBATE_FORM_Mapper,
		private _MLTT_REBATE_FORM_MAPPER: MLTT_REBATE_FORM_Mapper,
		private _MLTT_AFFIDAVIT_FORM_MAPPER: MLTT_AFFIDAVIT_FORM_Mapper,
		private _MLTT_SUPPLEMENTARY_FORM_MAPPER: MLTT_SUPPLEMENTARY_FORM_Mapper,
		private _FCT_UNDER_25_MAPPER: FCT_UNDER_25_Mapper,
		private _FCT_OVER_25_MAPPER: FCT_OVER_25_Mapper,
	) {}

	getCloserToFormMappingFile(form: PDFFormType): BaseFormMapper {
		switch (form) {
			case PDFFormType.ON_GST_190_CALCULATION_WS:
				return this._ON_GST_190_CALCULATION_WS_Mapper;
			case PDFFormType.ON_GST_190_APPENDIX_A:
				return this._ON_GST_190_APPENDIX_A_Mapper;
			case PDFFormType.ON_GST_190_REBATE_SCHEDULE:
				return this._ON_GST_190_REBATE_SCHEDULE_Mapper;
			case PDFFormType.ON_GST_NEW_REBATE_RENTAL:
				return this._ON_GST_NEW_REBATE_RENTAL_Mapper;
			case PDFFormType.ON_GST_NEW_HOUSING_REBATE:
				return this._ON_GST_NEW_HOUSING_REBATE_Mapper;
			case PDFFormType.ON_GST_524_REBATE_SCHEDULE:
				return this._ON_GST_524_REBATE_SCHEDULE_Mapper;

			case PDFFormType.RBC_COLLATERAL_FINAL_REPORT:
				return this._RBC_COLLATERAL_FINAL_REPORT_Mapper;
			case PDFFormType.RBC_COLLATERAL_REQUEST_FOR_FUNDS:
				return this._RBC_COLLATERAL_REQUEST_FOR_FUNDS_Mapper;
			case PDFFormType.RBC_COLLATERAL_SCHEDULE_FIXED_RATE:
				return this._RBC_COLLATERAL_SCHEDULE_FIXED_RATE_Mapper;
			case PDFFormType.RBC_COLLATERAL_SCHEDULE_PRIME_RATE:
				return this._RBC_RESIDENTIAL_SCHEDULE_PRIME_RATE_Mapper;
			case PDFFormType.RBC_COLLATERAL_STANDARD_CHARGE_TERMS:
				return this._RBC_RESIDENTIAL_STANDARD_CHARGE_TERMS_Mapper;

			case PDFFormType.RBC_RESIDENTIAL_ASSIGNMENT_OF_SITE_LEASE:
				return this._RBC_RESIDENTIAL_ASSIGNMENT_OF_SITE_LEASE_Mapper;
			case PDFFormType.RBC_RESIDENTIAL_FINAL_REPORT:
				return this._RBC_RESIDENTIAL_FINAL_REPORT_Mapper;
			case PDFFormType.RBC_RESIDENTIAL_LANDLORD_CONSENT:
				return this._RBC_RESIDENTIAL_LANDLORD_CONSENT_Mapper;
			case PDFFormType.RBC_RESIDENTIAL_LETTER_FOR_ILA:
				return this._RBC_RESIDENTIAL_LETTER_FOR_ILA_Mapper;
			case PDFFormType.RBC_RESIDENTIAL_LETTER_OF_DIRECTION:
				return this._RBC_RESIDENTIAL_LETTER_OF_DIRECTION_Mapper;
			case PDFFormType.RBC_RESIDENTIAL_REQUEST_FOR_FUNDS:
				return this._RBC_RESIDENTIAL_REQUEST_FOR_FUNDS_Mapper;
			case PDFFormType.RBC_RESIDENTIAL_SECURITY_AGREEMENT:
				return this._RBC_RESIDENTIAL_SECURITY_AGREEMENT_Mapper;
			case PDFFormType.RBC_RESIDENTIAL_SCT_VARIABLE:
				return this._RBC_RESIDENTIAL_SCT_VARIABLE_Mapper;
			case PDFFormType.RBC_RESIDENTIAL_SCT_FIXED:
				return this._RBC_RESIDENTIAL_SCT_FIXED_Mapper;

			case PDFFormType.BMO_COLLATERAL_FINAL_REPORT:
				return this._BMO_COLLATERAL_FINAL_REPORT_Mapper;
			case PDFFormType.BMO_COLLATERAL_REQUEST_FOR_FUNDS:
				return this._BMO_COLLATERAL_REQUEST_FOR_FUNDS_Mapper;
			case PDFFormType.BMO_COLLATERAL_SCHEDULE:
				return this._BMO_COLLATERAL_SCHEDULE_Mapper;
			case PDFFormType.BMO_COLLATERAL_STANDARD_CHARGE_TERMS:
				return this._BMO_COLLATERAL_STANDARD_CHARGE_TERMS_Mapper;

			case PDFFormType.BMO_CONVENTIONAL_ACKNOWLEDGEMENT_AND_DIRECTION:
				return this._BMO_CONVENTIONAL_ACKNOWLEDGEMENT_AND_DIRECTION_Mapper;
			case PDFFormType.BMO_CONVENTIONAL_COVER_SHEET:
				return this._BMO_CONVENTIONAL_COVER_SHEET_Mapper;
			case PDFFormType.BMO_CONVENTIONAL_FINAL_REPORT:
				return this._BMO_CONVENTIONAL_FINAL_REPORT_Mapper;
			case PDFFormType.BMO_CONVENTIONAL_ID_VERIFICATION:
				return this._BMO_CONVENTIONAL_ID_VERIFICATION_Mapper;
			case PDFFormType.BMO_CONVENTIONAL_MTG_DECLARATION_OF_POSSESSION:
				return this._BMO_CONVENTIONAL_MTG_DECLARATION_OF_POSSESSION_Mapper;
			case PDFFormType.BMO_CONVENTIONAL_RESIDENTIAL_MORTGAGE_SCHEDULE:
				return this._BMO_CONVENTIONAL_RESIDENTIAL_MORTGAGE_SCHEDULE_Mapper;
			case PDFFormType.BMO_CONVENTIONAL_REQUEST_FOR_FUNDS:
				return this._BMO_CONVENTIONAL_REQUEST_FOR_FUNDS_Mapper;

			case PDFFormType.HOME_TRUST_ACKNOWLEDGEMENT_AND_DIRECTION_REFUNDS:
				return this._HOME_TRUST_ACKNOWLEDGEMENT_AND_DIRECTION_REFUNDS_Mapper;
			case PDFFormType.HOME_TRUST_AUTHORIZATION_DIRECTION_AND_CONSENT:
				return this._HOME_TRUST_AUTHORIZATION_DIRECTION_AND_CONSENT_Mapper;
			case PDFFormType.HOME_TRUST_FINAL_REPORT:
				return this._HOME_TRUST_FINAL_REPORT_Mapper;
			case PDFFormType.HOME_TRUST_PAYMENT_CHANGE_REQUEST_FORM:
				return this._HOME_TRUST_PAYMENT_CHANGE_REQUEST_FORM_Mapper;
			case PDFFormType.HOME_TRUST_PREAUTHORIZED_DEBIT_AGREEMENT:
				return this._HOME_TRUST_PREAUTHORIZED_DEBIT_AGREEMENT_Mapper;
			case PDFFormType.HOME_TRUST_REQUEST_FOR_FUNDS:
				return this._HOME_TRUST_REQUEST_FOR_FUNDS_Mapper;
			case PDFFormType.HOME_TRUST_SOLICITOR_DECLARATION_REIDENTIFICATION:
				return this._HOME_TRUST_SOLICITOR_DECLARATION_REIDENTIFICATION_Mapper;
			case PDFFormType.HOME_TRUST_STANDARD_CHARGE_TERMS:
				return this._HOME_TRUST_STANDARD_CHARGE_TERMS_Mapper;
			case PDFFormType.HOME_TRUST_STATUTORY_DECLARATION:
				return this._HOME_TRUST_STATUTORY_DECLARATION_Mapper;
			case PDFFormType.HOME_TRUST_TENANT_ACKNOWLEDGEMENT:
				return this._HOME_TRUST_TENANT_ACKNOWLEDGEMENT_Mapper;

			case PDFFormType.FIRST_NATIONAL_REQUEST_FOR_FUNDS:
				return this._FIRST_NATIONAL_REQUEST_FOR_FUNDS_Mapper;
			case PDFFormType.FIRST_NATIONAL_REPORT_ON_TITLE:
				return this._FIRST_NATIONAL_FINAL_REPORT_ON_TITLE_Mapper;

			case PDFFormType.TD_REQUEST_FOR_FUNDS:
				return this._TD_REQUEST_FOR_FUNDS_Mapper;
			case PDFFormType.TD_FINAL_REPORT:
				return this._TD_FINAL_REPORT_Mapper;
			case PDFFormType.TD_FACE_TO_FACE_ID:
				return this._TD_FACE_TO_FACE_ID_Mapper;
			case PDFFormType.TD_PRIVACY_AGREEMENT:
				return this._TD_PRIVACY_AGREEMENT_Mapper;
			case PDFFormType.TD_NON_FACE_TO_FACE_ID:
				return this._TD_NON_FACE_TO_FACE_ID_Mapper;
			case PDFFormType.TD_SCHEDULE_1:
				return this._TD_SCHEDULE_1_Mapper;

			case PDFFormType.CIBC_DOCUMENTS_MORTGAGE_FINAL_REPORT:
				return this._CIBC_DOCUMENTS_MORTGAGE_FINAL_REPORT_Mapper;
			case PDFFormType.CIBC_DOCUMENTS_MORTGAGE_ID_VERIFICATION:
				return this._CIBC_DOCUMENTS_MORTGAGE_ID_VERIFICATION_Mapper;
			case PDFFormType.CIBC_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS:
				return this._CIBC_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS_Mapper;
			case PDFFormType.CIBC_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS:
				return this._CIBC_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS_Mapper;
			case PDFFormType.CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_FINAL_REPORT:
				return this._CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_FINAL_REPORT_Mapper;
			case PDFFormType.CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_NOTIFICATION_OF_REGISTRATION:
				return this
					._CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_NOTIFICATION_OF_REGISTRATION_Mapper;
			case PDFFormType.CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS:
				return this
					._CIBC_DOCUMENTS_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS_Mapper;
			case PDFFormType.CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_FINAL_REPORT:
				return this
					._CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_FINAL_REPORT_Mapper;
			case PDFFormType.CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS:
				return this
					._CIBC_DOCUMENTS_COMMERCIAL_COLLATERAL_MORTGAGE_REQUEST_FOR_FUNDS_Mapper;
			case PDFFormType.CIBC_DOCUMENTS_HOME_POWER_PLAN_FINAL_REPORT:
				return this._CIBC_DOCUMENTS_HOME_POWER_PLAN_FINAL_REPORT_Mapper;
			case PDFFormType.CIBC_DOCUMENTS_HOME_POWER_PLAN_ID_VERIFICATION:
				return this._CIBC_DOCUMENTS_HOME_POWER_PLAN_ID_VERIFICATION_Mapper;
			case PDFFormType.CIBC_DOCUMENTS_HOME_POWER_PLAN_REQUEST_FOR_FUNDS:
				return this._CIBC_DOCUMENTS_HOME_POWER_PLAN_REQUEST_FOR_FUNDS_Mapper;
			case PDFFormType.CIBC_DOCUMENTS_HOME_POWER_PLAN_STANDARD_CHARGE_TERMS:
				return this
					._CIBC_DOCUMENTS_HOME_POWER_PLAN_STANDARD_CHARGE_TERMS_Mapper;
			case PDFFormType.CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_FINAL_REPORT:
				return this._CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_FINAL_REPORT_Mapper;
			case PDFFormType.CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_REQUEST_FOR_FUNDS:
				return this._CIBC_DOCUMENTS_SPLC_FOR_PURCHASE_REQUEST_FOR_FUNDS_Mapper;
			case PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_FINAL_REPORT:
				return this
					._CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_FINAL_REPORT_Mapper;
			case PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS:
				return this
					._CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_REQUEST_FOR_FUNDS_Mapper;
			case PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS:
				return this
					._CIBC_SIMPLII_FINANCIAL_DOCUMENTS_MORTGAGE_STANDARD_CHARGE_TERMS_Mapper;
			case PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_FINAL_REPORT:
				return this
					._CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_FINAL_REPORT_Mapper;
			case PDFFormType.CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_REQUEST_FOR_FUNDS:
				return this
					._CIBC_SIMPLII_FINANCIAL_DOCUMENTS_SECURE_LINE_OF_CREDIT_REQUEST_FOR_FUNDS_Mapper;

			case PDFFormType.STANDALONE_PURCHASE_PRESCRIBED_INFORMATION_FORM:
				return this._STANDALONE_PURCHASE_PRESCRIBED_INFORMATION_FORM_Mapper;

			case PDFFormType.LTT_AFFIDAVIT_FORM:
				return this._LTT_AFFIDAVIT_FORM_MAPPER;
			case PDFFormType.LTT_REBATE_FORM:
				return this._LTT_REBATE_FORM_MAPPER;

			case PDFFormType.MLTT_AFFIDAVIT_FORM:
				return this._MLTT_AFFIDAVIT_FORM_MAPPER;
			case PDFFormType.MLTT_REBATE_FORM:
				return this._MLTT_REBATE_FORM_MAPPER;
			case PDFFormType.MLTT_SUPPLEMENTARY_FORM:
				return this._MLTT_SUPPLEMENTARY_FORM_MAPPER;

			case PDFFormType.FCT_UNDER_25:
				return this._FCT_UNDER_25_MAPPER;
			case PDFFormType.FCT_OVER_25:
				return this._FCT_OVER_25_MAPPER;
		}
	}
}
